import React from "react";
import Footer from "../components/Footer";
import { ReactComponent as Logo } from "../assets/images/logos/logo-login.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";
import Loader from "../utils/Loader";

const Login = () => {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0();

  if (isAuthenticated) {
    const redirectPath = sessionStorage.getItem("redirectPath") || "/dashboard";
    sessionStorage.removeItem("redirectPath");
    return <Navigate to={redirectPath} replace />;
  }

  if (isLoading) {
    return <Loader />;
  }

  const handleLogin = e => {
    e.preventDefault();
    loginWithRedirect();
  };

  return (
    <>
      <div className={"login__wrapper"}>
        <div className={"login__logo"}>
          <Logo />
        </div>
        <div className={"login__temp-class"}>
          <form>
            <h5>Login to TriloDocs:</h5>
            <div>You are not logged in.</div>
            <div className={"form-component login__form-component"}>
              <button
                onClick={handleLogin}
                className={"input-submit input-submit__primary"}>
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
